var $bptW5$react = require("react");
var $bptW5$reactjsxruntime = require("react/jsx-runtime");
var $bptW5$styledcomponents = require("styled-components");
var $bptW5$muiiconsmaterialExpandMore = require("@mui/icons-material/ExpandMore");

"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Accordion", {
    enumerable: true,
    get: function get() {
        return $02d2cf39577540ac$exports.Accordion;
    }
});
var $02d2cf39577540ac$exports = {};
"use strict";
function $02d2cf39577540ac$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $02d2cf39577540ac$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $02d2cf39577540ac$var$_typeof(o);
}
Object.defineProperty($02d2cf39577540ac$exports, "__esModule", {
    value: true
});
$02d2cf39577540ac$exports.handleChange = $02d2cf39577540ac$exports.Accordion = void 0;

var $02d2cf39577540ac$var$_react = $02d2cf39577540ac$var$_interopRequireWildcard($bptW5$react);
var $cdfea1d41732d543$exports = {};
"use strict";
Object.defineProperty($cdfea1d41732d543$exports, "__esModule", {
    value: true
});
$cdfea1d41732d543$exports.ExpandIcon = $cdfea1d41732d543$exports.AccordionWrapper = $cdfea1d41732d543$exports.AccordionPanelWrapper = $cdfea1d41732d543$exports.AccordionPanelHeaderTitle = $cdfea1d41732d543$exports.AccordionPanelHeader = $cdfea1d41732d543$exports.AccordionPanelContent = $cdfea1d41732d543$exports.AccordionOptions = void 0;

var $cdfea1d41732d543$var$_styledComponents = $cdfea1d41732d543$var$_interopRequireDefault($bptW5$styledcomponents);

var $cdfea1d41732d543$var$_ExpandMore = $cdfea1d41732d543$var$_interopRequireDefault($bptW5$muiiconsmaterialExpandMore);
var $cdfea1d41732d543$var$_templateObject, $cdfea1d41732d543$var$_templateObject2, $cdfea1d41732d543$var$_templateObject3, $cdfea1d41732d543$var$_templateObject4, $cdfea1d41732d543$var$_templateObject5, $cdfea1d41732d543$var$_templateObject6, $cdfea1d41732d543$var$_templateObject7;
function $cdfea1d41732d543$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
function $cdfea1d41732d543$var$_taggedTemplateLiteral(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}
var $cdfea1d41732d543$var$AccordionWrapper = $cdfea1d41732d543$exports.AccordionWrapper = $cdfea1d41732d543$var$_styledComponents["default"].div($cdfea1d41732d543$var$_templateObject || ($cdfea1d41732d543$var$_templateObject = $cdfea1d41732d543$var$_taggedTemplateLiteral([
    ""
])));
var $cdfea1d41732d543$var$ExpandIcon = $cdfea1d41732d543$exports.ExpandIcon = (0, $cdfea1d41732d543$var$_styledComponents["default"])($cdfea1d41732d543$var$_ExpandMore["default"]).attrs(function() {
    return {
        classes: {
            root: "root"
        }
    };
})($cdfea1d41732d543$var$_templateObject2 || ($cdfea1d41732d543$var$_templateObject2 = $cdfea1d41732d543$var$_taggedTemplateLiteral([
    "\n  &.root {\n    color: ",
    ";\n\n    transition: all 0.3s ease;\n    transform: ",
    ";\n  }\n"
])), function(props) {
    return props.theme.color.g500;
}, function(props) {
    return props.sc.isOpen ? "rotate(180deg)" : "rotate(0)";
});
var $cdfea1d41732d543$var$AccordionPanelHeader = $cdfea1d41732d543$exports.AccordionPanelHeader = $cdfea1d41732d543$var$_styledComponents["default"].div($cdfea1d41732d543$var$_templateObject3 || ($cdfea1d41732d543$var$_templateObject3 = $cdfea1d41732d543$var$_taggedTemplateLiteral([
    "\n  display: flex;\n  cursor: pointer;\n  padding: 16px 10px;\n  position: relative;\n  align-items: center;\n  justify-content: space-between;\n"
])));
var $cdfea1d41732d543$var$AccordionPanelHeaderTitle = $cdfea1d41732d543$exports.AccordionPanelHeaderTitle = $cdfea1d41732d543$var$_styledComponents["default"].div($cdfea1d41732d543$var$_templateObject4 || ($cdfea1d41732d543$var$_templateObject4 = $cdfea1d41732d543$var$_taggedTemplateLiteral([
    "\n  flex: 1 1 auto;\n  overflow: hidden;\n  ",
    ";\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  ",
    ";\n\n  color: ",
    ";\n"
])), function(props) {
    return props.theme.fontWeight.medium;
}, function(props) {
    return props.theme.typo.bodyM;
}, function(props) {
    return props.sc.isOpen ? props.theme.color.p500 : props.theme.color.g600;
});
var $cdfea1d41732d543$var$AccordionOptions = $cdfea1d41732d543$exports.AccordionOptions = $cdfea1d41732d543$var$_styledComponents["default"].div($cdfea1d41732d543$var$_templateObject5 || ($cdfea1d41732d543$var$_templateObject5 = $cdfea1d41732d543$var$_taggedTemplateLiteral([
    ""
])));
var $cdfea1d41732d543$var$AccordionPanelContent = $cdfea1d41732d543$exports.AccordionPanelContent = $cdfea1d41732d543$var$_styledComponents["default"].div($cdfea1d41732d543$var$_templateObject6 || ($cdfea1d41732d543$var$_templateObject6 = $cdfea1d41732d543$var$_taggedTemplateLiteral([
    "\n  ",
    ";\n\n  height: auto;\n  padding: 0 10px;\n  overflow: hidden;\n  transition: height 0.3s ease-out;\n"
])), function(props) {
    return props.theme.typo.bodyM;
});
var $cdfea1d41732d543$var$AccordionPanelWrapper = $cdfea1d41732d543$exports.AccordionPanelWrapper = $cdfea1d41732d543$var$_styledComponents["default"].div($cdfea1d41732d543$var$_templateObject7 || ($cdfea1d41732d543$var$_templateObject7 = $cdfea1d41732d543$var$_taggedTemplateLiteral([
    "\n  box-shadow: ",
    ";\n\n  margin-bottom: 10px;\n  border-left: ",
    ";\n  transition: border 0.25s ease-in;\n\n  ",
    "\n  ",
    "\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n\n  &:hover {\n    box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.07);\n  }\n"
])), function(props) {
    return !props.sc.isOpen ? "0px 3px 10px rgba(0, 0, 0, 0.07)" : "0px 6px 10px rgba(0, 0, 0, 0.07)";
}, function(props) {
    return "2px solid ".concat(props.sc.isOpen ? props.theme.color.p500 : "transparent");
}, function(props) {
    return props.sc.isOpen && "padding-bottom: 16px;";
}, function(props) {
    return !props.sc.allowExpansion && "padding-right: 24px;";
});



function $02d2cf39577540ac$var$_getRequireWildcardCache(e) {
    if ("function" != typeof WeakMap) return null;
    var r = new WeakMap(), t = new WeakMap();
    return ($02d2cf39577540ac$var$_getRequireWildcardCache = function _getRequireWildcardCache(e) {
        return e ? t : r;
    })(e);
}
function $02d2cf39577540ac$var$_interopRequireWildcard(e, r) {
    if (!r && e && e.__esModule) return e;
    if (null === e || "object" != $02d2cf39577540ac$var$_typeof(e) && "function" != typeof e) return {
        "default": e
    };
    var t = $02d2cf39577540ac$var$_getRequireWildcardCache(r);
    if (t && t.has(e)) return t.get(e);
    var n = {
        __proto__: null
    }, a = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var u in e)if ("default" !== u && ({}).hasOwnProperty.call(e, u)) {
        var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
        i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
    return n["default"] = e, t && t.set(e, n), n;
}
function $02d2cf39577540ac$var$_slicedToArray(r, e) {
    return $02d2cf39577540ac$var$_arrayWithHoles(r) || $02d2cf39577540ac$var$_iterableToArrayLimit(r, e) || $02d2cf39577540ac$var$_unsupportedIterableToArray(r, e) || $02d2cf39577540ac$var$_nonIterableRest();
}
function $02d2cf39577540ac$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $02d2cf39577540ac$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $02d2cf39577540ac$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $02d2cf39577540ac$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $02d2cf39577540ac$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $02d2cf39577540ac$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $02d2cf39577540ac$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var $02d2cf39577540ac$var$handleChange = $02d2cf39577540ac$exports.handleChange = function handleChange(_ref) {
    var onChange = _ref.onChange, isOpen = _ref.isOpen, setIsOpened = _ref.setIsOpened, allowExpansion = _ref.allowExpansion;
    return function() {
        if (allowExpansion) {
            setIsOpened(!isOpen);
            if (onChange) onChange(!isOpen);
        }
    };
};
var $02d2cf39577540ac$var$Accordion = $02d2cf39577540ac$exports.Accordion = function Accordion(props) {
    var title = props.title, _props$children = props.children, children = _props$children === void 0 ? null : _props$children, onChange = props.onChange, _props$className = props.className, className = _props$className === void 0 ? null : _props$className, _props$allowExpansion = props.allowExpansion, allowExpansion = _props$allowExpansion === void 0 ? true : _props$allowExpansion, _props$isOpen = props.isOpen, isOpen = _props$isOpen === void 0 ? false : _props$isOpen, _props$options = props.options, options = _props$options === void 0 ? null : _props$options;
    var contentRef = (0, $02d2cf39577540ac$var$_react.useRef)(null);
    var _useState = (0, $02d2cf39577540ac$var$_react.useState)(isOpen), _useState2 = $02d2cf39577540ac$var$_slicedToArray(_useState, 2), isOpened = _useState2[0], setIsOpened = _useState2[1];
    var onClick = $02d2cf39577540ac$var$handleChange({
        onChange: onChange,
        isOpen: isOpened,
        setIsOpened: setIsOpened,
        allowExpansion: allowExpansion
    });
    (0, $02d2cf39577540ac$var$_react.useEffect)(function() {
        setIsOpened(isOpen);
    }, [
        isOpen
    ]);
    (0, $02d2cf39577540ac$var$_react.useEffect)(function() {
        var contentElement = contentRef.current;
        contentElement.style.height = isOpened ? "".concat(contentElement.scrollHeight, "px") : 0;
    }, [
        isOpened
    ]);
    var open = allowExpansion && isOpened;
    return /*#__PURE__*/ (0, $bptW5$reactjsxruntime.jsxs)($cdfea1d41732d543$exports.AccordionPanelWrapper, {
        sc: {
            isOpen: open,
            allowExpansion: allowExpansion
        },
        className: className,
        children: [
            /*#__PURE__*/ (0, $bptW5$reactjsxruntime.jsxs)($cdfea1d41732d543$exports.AccordionPanelHeader, {
                className: "".concat(className ? "".concat(className, "-header") : "header"),
                onClick: onClick,
                "data-testid": "header",
                children: [
                    /*#__PURE__*/ (0, $bptW5$reactjsxruntime.jsx)($cdfea1d41732d543$exports.AccordionPanelHeaderTitle, {
                        className: "".concat(className ? "".concat(className, "-title") : "title"),
                        sc: {
                            isOpen: open
                        },
                        children: title
                    }),
                    options && /*#__PURE__*/ (0, $bptW5$reactjsxruntime.jsx)($cdfea1d41732d543$exports.AccordionOptions, {
                        children: options
                    }),
                    allowExpansion && /*#__PURE__*/ (0, $bptW5$reactjsxruntime.jsx)($cdfea1d41732d543$exports.ExpandIcon, {
                        sc: {
                            isOpen: open
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0, $bptW5$reactjsxruntime.jsx)($cdfea1d41732d543$exports.AccordionPanelContent, {
                className: "".concat(className ? "".concat(className, "-content") : "content", " ").concat(isOpened ? "open" : ""),
                ref: contentRef,
                children: children
            })
        ]
    });
};




//# sourceMappingURL=index.js.map
